import React, {useEffect, useState} from 'react';
import { CustomDatePicker, StyledPopUp} from "../../../../../shared";
import {Button, Card, Col, Flex, Form, message, Row} from "antd";
import {useForm} from "antd/es/form/Form";
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian"
import gregorian from "react-date-object/calendars/gregorian"
import persian_fa from "react-date-object/locales/persian_fa"
import TextArea from "antd/es/input/TextArea";
import styled from "./RentFormPopUp.module.scss";
import {connect} from "react-redux";
import {withRouter} from "../../../../../utils/services/with-router";
import {useParams} from "react-router-dom";
import {RentFormPopUpProps} from "../../../models";
import {getCalculatedProductPrice, registerBorrowRequest} from "../../../actions/Product.action";

const RentFormPopUp = ({open,onCansel ,getCalculatedProductPrice,registerBorrowRequest} :RentFormPopUpProps) => {
    const [form] = useForm();
    const { id } = useParams();
    const [startDate, setStartDate] = useState<any>()
    const [endDate, setEndDate] = useState<any>()
    const [sum, setSum] = useState<any>()
    const [minDate, setMinDate] = useState<string>('');
    const [laoding, setLoading] = useState<boolean>(false);

    const convertPersianToEnglish = (persianStr: string) => {
        return persianStr.replace(/[۰-۹]/g, (digit) => "۰۱۲۳۴۵۶۷۸۹".indexOf(digit).toString());
    };
    const onFinish = (value  : any) => {
        setLoading(true)
        let model: any = {
            productId: id,
            startDate:value.startDate,
            endDate:value.endDate,
            borrowerDescription:value.borrowerDescription
        }
        registerBorrowRequest(model).then((data: any) => {
            setLoading(false)

            if (data.payload != undefined) {
                message.success('درخواست با موفقیت ارسال شد')
                onCansel()
            }
        })
            .catch((e: any) => {
            });
    }
    const _getCalculatedProductPrice = () => {
        let model: any = {
            ProductId: id,
            startDate:startDate,
            endDate:endDate
        }
        getCalculatedProductPrice(model).then((data: any) => {
                if (data.payload != undefined) {

                    setSum(data?.payload?.data?.sum);
                } else {
                }
            })
            .catch((e: any) => {
            });
    };
    useEffect(() => {
        if (startDate && endDate) _getCalculatedProductPrice()
    }, [startDate,endDate]);
    return (
        <StyledPopUp
        open={open}
        onCancel={onCansel}
        title={'همین حالا اجاره کن!'}
        width={"100%"}
        footer={null}
        closable={false}
        transitionName={''}
        >
            <Form layout={"vertical"} form={form} onFinish={onFinish}>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} align={"middle"}>
                    <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={12}
                    >
                        <Form.Item name={"startDate"} label={'تاریخ درخواستی از'}>
                            <CustomDatePicker>
                                <DatePicker
                                    format="MM/DD/YYYY HH:mm"
                                    plugins={[
                                        <TimePicker position="bottom" hideSeconds />
                                    ]}
                                    calendar={persian}
                                    locale={persian_fa}
                                    calendarPosition="bottom-right"
                                    onChange={(date: DateObject) => {
                                        const formattedDate = date.convert(gregorian).format("YYYY-MM-DD HH:mm");
                                        const englishDate = convertPersianToEnglish(formattedDate); // Convert Persian numbers to English
                                        setStartDate(englishDate)
                                        let expirationDate = new DateObject({
                                            date: new Date(date.toDate()),
                                            calendar: persian,
                                        });
                                        form.setFieldValue('startDate' , new Date(date.toDate()))
                                        setMinDate(expirationDate.toString())
                                    }}
                                />
                            </CustomDatePicker>
                        </Form.Item>
                    </Col>
                    <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={12}
                    >
                        <Form.Item name={"endDate"} label={'تاریخ درخواستی تا'}>
                            <CustomDatePicker>
                                <DatePicker
                                    disabled={startDate == undefined}
                                    format="MM/DD/YYYY HH:mm"
                                    plugins={[
                                        <TimePicker position="bottom" hideSeconds/>
                                    ]}
                                    minDate={minDate}
                                    calendar={persian}
                                    locale={persian_fa}
                                    calendarPosition="bottom-right"
                                    onChange={(date: DateObject) => {
                                        const formattedDate = date.convert(gregorian).format("YYYY-MM-DD HH:mm");
                                        const englishDate = convertPersianToEnglish(formattedDate); // Convert Persian numbers to English

                                        form.setFieldValue('endDate' , new Date(date.toDate()))
                                        setEndDate(englishDate)
                                    }}
                                />
                            </CustomDatePicker>
                        </Form.Item>
                    </Col>
                    {(sum && sum !== 0) && <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={24}
                        xl={24}
                    >

                        <Flex gap={"middle"}>
                            <span>هزینه محاسبه شده : </span>
                            <span className={styled.price}>{sum?.toString().replace(
                                /\B(?=(\d{3})+(?!\d))/g,
                                ","
                            )} ت </span>

                        </Flex>
                    </Col>}
                    <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={24}
                        xl={24}
                    >
                        <Form.Item name={"borrowerDescription"} label={'توضیحات'}>
                          <TextArea rows={5}/>
                        </Form.Item>
                    </Col>
                    <Button loading={laoding} type={"primary"} htmlType={"submit"} block size={"large"}>ارسال</Button>

                </Row>
            </Form>

        </StyledPopUp>
    );
};

export default connect(null, {getCalculatedProductPrice,registerBorrowRequest})(withRouter(RentFormPopUp));
